import { VRow, VDialog, VBtn, VCard, VCardTitle, VCardText, VCardActions, VSpacer, VLayout, VFlex, VProgressCircular, VContainer } from 'vuetify/lib';

const configDefault = {
  icon: "info",
  iconVisible: true,
  title: "Default",
  maxWidth: "500px",
  class: "",
  buttonCancel: {
    visible: true,
    text: "Cancel",
    valueReturn: false,
    close: true,
    emitEventClick: "clickButtonCancel",
    style: {
      text: false,
      color: "error",
      class: "",
      depressed: true,
      width: "30%",
      maxWidth: "200px",
      minWidth: "100px"
    }
  },
  buttonOk: {
    visible: true,
    text: "Ok",
    valueReturn: true,
    close: true,
    emitEventClick: "clickButtonOk",
    style: {
      text: false,
      color: "primary",
      class: "",
      depressed: true,
      width: "30%",
      maxWidth: "200px",
      minWidth: "100px"
    }
  },
  loading: {
    text: 'Loading...',
    style: {
      size: 100,
      color: 'primary',
      width: '4',
      indeterminate: true
    }
  }
};
const configDefaultSuccess = {
  icon: "success",
  iconVisible: true,
  title: "Success",
  maxWidth: "500px",
  class: "",
  buttonCancel: {
    visible: false,
    text: "Cancel",
    valueReturn: false,
    close: true,
    emitEventClick: "clickButtonCancel",
    style: {
      text: false,
      color: "error",
      class: "",
      depressed: true,
      width: "30%",
      maxWidth: "200px",
      minWidth: "100px"
    }
  },
  buttonOk: {
    visible: true,
    text: "Ok",
    valueReturn: true,
    close: true,
    emitEventClick: "clickButtonOk",
    style: {
      text: false,
      color: "green darken-1",
      class: "white--text",
      depressed: true,
      width: "20%",
      maxWidth: "200px",
      minWidth: "100px"
    }
  },
  loading: {
    text: 'Loading...',
    style: {
      size: 100,
      color: 'primary',
      width: '4',
      indeterminate: true
    }
  }
};
const configDefaultError = {
  icon: "error",
  iconVisible: true,
  title: "Error",
  maxWidth: "500px",
  class: "",
  buttonCancel: {
    visible: false,
    text: "Cancel",
    valueReturn: false,
    close: true,
    emitEventClick: "clickButtonCancel",
    style: {
      text: false,
      color: "error",
      class: "",
      depressed: true,
      width: "30%",
      maxWidth: "200px",
      minWidth: "100px"
    }
  },
  buttonOk: {
    visible: true,
    text: "Ok",
    valueReturn: true,
    close: true,
    emitEventClick: "clickButtonOk",
    style: {
      text: false,
      color: "error",
      class: "",
      depressed: true,
      width: "20%",
      maxWidth: "200px",
      minWidth: "100px"
    }
  },
  loading: {
    text: 'Loading...',
    style: {
      size: 100,
      color: 'primary',
      width: '4',
      indeterminate: true
    }
  }
};
const configDefaultConfirm = {
  icon: "info",
  iconVisible: true,
  title: "Confirm",
  maxWidth: "500px",
  class: "",
  buttonCancel: {
    visible: true,
    text: "Cancel",
    valueReturn: false,
    close: true,
    emitEventClick: "clickButtonCancel",
    style: {
      text: false,
      color: "error",
      class: "",
      depressed: true,
      width: "30%",
      maxWidth: "200px",
      minWidth: "100px"
    }
  },
  buttonOk: {
    visible: true,
    text: "Ok",
    valueReturn: true,
    close: true,
    emitEventClick: "clickButtonOk",
    style: {
      text: false,
      color: "primary",
      class: "",
      depressed: true,
      width: "20%",
      maxWidth: "200px",
      minWidth: "100px"
    }
  },
  loading: {
    text: 'Loading...',
    style: {
      size: 100,
      color: 'primary',
      width: '4',
      indeterminate: true
    }
  }
};
const configDefaultLoading = {
  icon: "",
  iconVisible: true,
  title: "",
  maxWidth: "500px",
  class: "",
  buttonCancel: {},
  buttonOk: {},
  loading: {
    text: 'Loading...',
    style: {
      size: 100,
      color: 'primary',
      width: '4',
      indeterminate: true
    }
  }
};

const getDefault = type => {
  switch (type) {
    case "success":
      return configDefaultSuccess;

    case "error":
      return configDefaultError;

    case "confirm":
      return configDefaultConfirm;

    case "loading":
      return configDefaultLoading;

    default:
      return configDefault;
  }
};

//
var script = /*#__PURE__*/{
  name: 'TSweetAlertVuetify',
  // vue component name
  components: {
    VRow,
    VDialog,
    VBtn,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VSpacer,
    VLayout,
    VFlex,
    VProgressCircular,
    VContainer
  },
  model: {
    prop: "modelSweet"
  },
  props: {
    modelSweet: {
      type: Boolean,
      default: false
    },
    alertDefault: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => {
        return configDefault;
      }
    },
    closeDestroy: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dialog: false,
      configDefault: configDefault,
      configButtonOk: null,
      configButtonCancel: null,
      configLoading: null,
      valueReturn: false,
      showLoading: false
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    getConfigIcon() {
      var _this$config;

      return ((_this$config = this.config) === null || _this$config === void 0 ? void 0 : _this$config.icon) ?? this.configDefault.icon;
    },

    getIconVisible() {
      var _this$config2;

      return ((_this$config2 = this.config) === null || _this$config2 === void 0 ? void 0 : _this$config2.iconVisible) ?? this.configDefault.iconVisible;
    },

    getTitle() {
      var _this$config3;

      return ((_this$config3 = this.config) === null || _this$config3 === void 0 ? void 0 : _this$config3.title) ?? this.configDefault.title;
    },

    getSubtitle() {
      var _this$config4;

      return ((_this$config4 = this.config) === null || _this$config4 === void 0 ? void 0 : _this$config4.subtitle) ?? this.configDefault.subtitle;
    },

    getMaxWidth() {
      var _this$config5;

      return ((_this$config5 = this.config) === null || _this$config5 === void 0 ? void 0 : _this$config5.maxWidth) ?? this.configDefault.maxWidth;
    },

    getClass() {
      var _this$config6;

      return ((_this$config6 = this.config) === null || _this$config6 === void 0 ? void 0 : _this$config6.class) ?? this.configDefault.class;
    },

    isSuccess() {
      return this.getConfigIcon == "success" && this.getIconVisible;
    },

    isError() {
      return this.getConfigIcon == "error" && this.getIconVisible;
    },

    isInfo() {
      return this.getConfigIcon == "info" && this.getIconVisible;
    },

    getStyleButtonCancel() {
      let objStyle = { ...this.configButtonCancel.style
      };
      objStyle["class"] += this.configButtonOk.visible ? " mr-1" : "";

      if (this.isMobile) {
        objStyle['width'] = '46%';
      }

      return objStyle;
    },

    getStyleButtonOk() {
      let objStyle = { ...this.configButtonOk.style
      };
      objStyle["class"] += this.configButtonCancel.visible ? " ml-1" : "";

      if (this.isMobile) {
        objStyle['width'] = '46%';
      }

      return objStyle;
    }

  },
  methods: {
    setConfigButtonCancel() {
      var _this$config7, _this$config7$buttonC, _this$config8, _this$config8$buttonC, _this$config9, _this$config9$buttonC, _this$config10, _this$config10$button, _this$config11, _this$config11$button, _this$config12, _this$config12$button;

      this.configButtonCancel = {
        visible: ((_this$config7 = this.config) === null || _this$config7 === void 0 ? void 0 : (_this$config7$buttonC = _this$config7.buttonCancel) === null || _this$config7$buttonC === void 0 ? void 0 : _this$config7$buttonC.visible) ?? this.configDefault.buttonCancel.visible,
        text: ((_this$config8 = this.config) === null || _this$config8 === void 0 ? void 0 : (_this$config8$buttonC = _this$config8.buttonCancel) === null || _this$config8$buttonC === void 0 ? void 0 : _this$config8$buttonC.text) ?? this.configDefault.buttonCancel.text,
        valueReturn: ((_this$config9 = this.config) === null || _this$config9 === void 0 ? void 0 : (_this$config9$buttonC = _this$config9.buttonCancel) === null || _this$config9$buttonC === void 0 ? void 0 : _this$config9$buttonC.valueReturn) ?? this.configDefault.buttonCancel.valueReturn,
        close: ((_this$config10 = this.config) === null || _this$config10 === void 0 ? void 0 : (_this$config10$button = _this$config10.buttonCancel) === null || _this$config10$button === void 0 ? void 0 : _this$config10$button.close) ?? this.configDefault.buttonCancel.close,
        emitEventClick: ((_this$config11 = this.config) === null || _this$config11 === void 0 ? void 0 : (_this$config11$button = _this$config11.buttonCancel) === null || _this$config11$button === void 0 ? void 0 : _this$config11$button.emitEventClick) ?? this.configDefault.buttonCancel.emitEventClick,
        style: ((_this$config12 = this.config) === null || _this$config12 === void 0 ? void 0 : (_this$config12$button = _this$config12.buttonCancel) === null || _this$config12$button === void 0 ? void 0 : _this$config12$button.style) ?? this.configDefault.buttonCancel.style
      };
    },

    setConfigButtonOk() {
      var _this$config13, _this$config13$button, _this$config14, _this$config14$button, _this$config15, _this$config15$button, _this$config16, _this$config16$button, _this$config17, _this$config17$button, _this$config18, _this$config18$button;

      this.configButtonOk = {
        visible: ((_this$config13 = this.config) === null || _this$config13 === void 0 ? void 0 : (_this$config13$button = _this$config13.buttonOk) === null || _this$config13$button === void 0 ? void 0 : _this$config13$button.visible) ?? this.configDefault.buttonOk.visible,
        text: ((_this$config14 = this.config) === null || _this$config14 === void 0 ? void 0 : (_this$config14$button = _this$config14.buttonOk) === null || _this$config14$button === void 0 ? void 0 : _this$config14$button.text) ?? this.configDefault.buttonOk.text,
        valueReturn: ((_this$config15 = this.config) === null || _this$config15 === void 0 ? void 0 : (_this$config15$button = _this$config15.buttonOk) === null || _this$config15$button === void 0 ? void 0 : _this$config15$button.valueReturn) ?? this.configDefault.buttonOk.valueReturn,
        close: ((_this$config16 = this.config) === null || _this$config16 === void 0 ? void 0 : (_this$config16$button = _this$config16.buttonOk) === null || _this$config16$button === void 0 ? void 0 : _this$config16$button.close) ?? this.configDefault.buttonOk.close,
        emitEventClick: ((_this$config17 = this.config) === null || _this$config17 === void 0 ? void 0 : (_this$config17$button = _this$config17.buttonOk) === null || _this$config17$button === void 0 ? void 0 : _this$config17$button.emitEventClick) ?? this.configDefault.buttonOk.emitEventClick,
        style: ((_this$config18 = this.config) === null || _this$config18 === void 0 ? void 0 : (_this$config18$button = _this$config18.buttonOk) === null || _this$config18$button === void 0 ? void 0 : _this$config18$button.style) ?? this.configDefault.buttonOk.style
      };
    },

    setConfigLoading() {
      var _this$config19, _this$config19$loadin, _this$config20, _this$config20$loadin;

      this.configLoading = {
        text: ((_this$config19 = this.config) === null || _this$config19 === void 0 ? void 0 : (_this$config19$loadin = _this$config19.loading) === null || _this$config19$loadin === void 0 ? void 0 : _this$config19$loadin.text) ?? this.configDefault.loading.text,
        style: ((_this$config20 = this.config) === null || _this$config20 === void 0 ? void 0 : (_this$config20$loadin = _this$config20.loading) === null || _this$config20$loadin === void 0 ? void 0 : _this$config20$loadin.style) ?? this.configDefault.loading.style
      };
    },

    updateConfigAlert() {
      this.setConfigButtonCancel();
      this.setConfigButtonOk();
      this.setConfigLoading();
    },

    updateConfigDefault() {
      this.configDefault = { ...getDefault(this.alertDefault)
      };
    },

    updateLoading() {
      this.showLoading = this.loading;
      if (this.alertDefault === "loading") this.showLoading = true;
    },

    closeAlert(button) {
      this.valueReturn = (button === null || button === void 0 ? void 0 : button.valueReturn) ?? false;

      if (button !== null && button !== void 0 && button.emitEventClick) {
        this.$emit(button.emitEventClick, this.valueReturn);
      }

      this.$emit("change", this.valueReturn);

      if (button !== null && button !== void 0 && button.close) {
        this.$emit("input", false);
        this.close();
      }
    },

    openAlert() {
      this.dialog = true;
      this.$emit("input", true);
      document.addEventListener('keyup', this.onEnterPressed);
    },

    onEnterPressed(e) {
      if (e.keyCode === 13 && !this.showLoading) {
        e.stopPropagation();
        this.closeAlert(this.configButtonOk);
      }
    },

    close() {
      this.dialog = false;
      document.removeEventListener('keyup', this.onEnterPressed); //Vue.property.$swal => this.closeDestroy = true

      if (this.closeDestroy) this.$destroy();
    }

  },

  mounted() {
    this.updateLoading();
    this.updateConfigDefault();
    this.updateConfigAlert();
    if (this.modelSweet) this.openAlert();
  },

  watch: {
    modelSweet() {
      this.modelSweet ? this.openAlert() : this.close();
    },

    alertDefault() {
      this.updateConfigDefault();
    },

    config: {
      handler: function () {
        this.updateConfigAlert();
      },
      deep: true
    },

    loading() {
      this.updateLoading();
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('v-row', {
    staticClass: "mt-10",
    attrs: {
      "justify": "center"
    }
  }, [_vm.dialog ? _c('v-dialog', {
    class: _vm.getClass,
    attrs: {
      "persistent": "",
      "max-width": _vm.getMaxWidth
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pb-0"
  }, [_vm.showLoading ? _c('div', {
    staticClass: "text-center"
  }, [_c('v-container', {
    staticClass: "sweet-loader",
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', [_c('v-progress-circular', _vm._b({}, 'v-progress-circular', _vm.configLoading.style, false))], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), !_vm.showLoading ? _c('div', {
    staticClass: "text-center"
  }, [_vm.isSuccess ? _c('div', {
    staticClass: "svg-box"
  }, [_c('svg', {
    staticClass: "circular green-stroke"
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "75",
      "cy": "75",
      "r": "50",
      "fill": "none",
      "stroke-width": "5",
      "stroke-miterlimit": "10"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "checkmark green-stroke"
  }, [_c('g', {
    attrs: {
      "transform": "matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-489.57,-205.679)"
    }
  }, [_c('path', {
    staticClass: "checkmark__check",
    attrs: {
      "fill": "none",
      "d": "M616.306,283.025L634.087,300.805L673.361,261.53"
    }
  })])])]) : _vm._e(), _vm._v(" "), _vm.isError ? _c('div', {
    staticClass: "svg-box"
  }, [_c('svg', {
    staticClass: "circular red-stroke"
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "75",
      "cy": "75",
      "r": "50",
      "fill": "none",
      "stroke-width": "5",
      "stroke-miterlimit": "10"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "cross red-stroke"
  }, [_c('g', {
    attrs: {
      "transform": "matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)"
    }
  }, [_c('path', {
    staticClass: "first-line",
    attrs: {
      "d": "M634.087,300.805L673.361,261.53",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)"
    }
  }, [_c('path', {
    staticClass: "second-line",
    attrs: {
      "d": "M634.087,300.805L673.361,261.53"
    }
  })])])]) : _vm._e(), _vm._v(" "), _vm.isInfo ? _c('div', {
    staticClass: "svg-box"
  }, [_c('svg', {
    staticClass: "circular yellow-stroke"
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "75",
      "cy": "75",
      "r": "50",
      "fill": "none",
      "stroke-width": "5",
      "stroke-miterlimit": "10"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "alert-sign yellow-stroke"
  }, [_c('g', {
    attrs: {
      "transform": "matrix(1,0,0,1,-615.516,-257.346)"
    }
  }, [_c('g', {
    attrs: {
      "transform": "matrix(0.56541,-0.56541,0.56541,0.56541,93.7153,495.69)"
    }
  }, [_c('path', {
    staticClass: "line",
    attrs: {
      "d": "M634.087,300.805L673.361,261.53",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(2.27612,-2.46519e-32,0,2.27612,-792.339,-404.147)"
    }
  }, [_c('circle', {
    staticClass: "dot",
    attrs: {
      "cx": "621.52",
      "cy": "316.126",
      "r": "1.318"
    }
  })])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center"
  }, [!_vm.showLoading ? _c('div', [_vm._v(_vm._s(_vm.getTitle))]) : _vm._e(), _vm._v(" "), _vm.showLoading ? _c('div', [_vm._v(_vm._s(_vm.configLoading.text))]) : _vm._e()]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-center"
  }, [_vm._t("content", [_vm.getSubtitle !== '' ? _c('p', {
    staticClass: "body-2"
  }, [_vm._v(_vm._s(_vm.getSubtitle))]) : _vm._e()])], 2), _vm._v(" "), !_vm.showLoading ? _c('v-card-actions', {
    staticClass: "mb-4"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-center",
    attrs: {
      "justify-center": ""
    }
  }, [_vm.configButtonCancel.visible ? _c('v-btn', _vm._b({
    on: {
      "click": function ($event) {
        return _vm.closeAlert(_vm.configButtonCancel);
      }
    }
  }, 'v-btn', _vm.getStyleButtonCancel, false), [_vm._v("\n                " + _vm._s(_vm.configButtonCancel.text) + "\n              ")]) : _vm._e(), _vm._v(" "), _vm.configButtonOk.visible ? _c('v-btn', _vm._b({
    on: {
      "click": function ($event) {
        return _vm.closeAlert(_vm.configButtonOk);
      }
    }
  }, 'v-btn', _vm.getStyleButtonOk, false), [_vm._v("\n                " + _vm._s(_vm.configButtonOk.text) + "\n              ")]) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-31b284ae_0", {
    source: ".sweet-loader[data-v-31b284ae]{min-height:150px}.v-card[data-v-31b284ae]{overflow:hidden!important}.svg-box[data-v-31b284ae]{display:inline-block;position:relative;width:150px}.green-stroke[data-v-31b284ae]{stroke:#7cb342}.red-stroke[data-v-31b284ae]{stroke:#ff6245}.yellow-stroke[data-v-31b284ae]{stroke:#ffc107}.circular circle.path[data-v-31b284ae]{stroke-dasharray:330;stroke-dashoffset:0;stroke-linecap:round;opacity:.4;animation:.7s draw-circle-data-v-31b284ae ease-out}.checkmark[data-v-31b284ae]{stroke-width:6.25;stroke-linecap:round;position:absolute;top:56px;left:49px;width:52px;height:40px}.checkmark path[data-v-31b284ae]{animation:1s draw-check-data-v-31b284ae ease-out}@keyframes draw-circle-data-v-31b284ae{0%{stroke-dasharray:0,330;stroke-dashoffset:0;opacity:1}80%{stroke-dasharray:330,330;stroke-dashoffset:0;opacity:1}100%{opacity:.4}}@keyframes draw-check-data-v-31b284ae{0%{stroke-dasharray:49,80;stroke-dashoffset:48;opacity:0}50%{stroke-dasharray:49,80;stroke-dashoffset:48;opacity:1}100%{stroke-dasharray:130,80;stroke-dashoffset:48}}.cross[data-v-31b284ae]{stroke-width:6.25;stroke-linecap:round;position:absolute;top:54px;left:54px;width:40px;height:40px}.cross .first-line[data-v-31b284ae]{animation:.7s draw-first-line-data-v-31b284ae ease-out}.cross .second-line[data-v-31b284ae]{animation:.7s draw-second-line-data-v-31b284ae ease-out}@keyframes draw-first-line-data-v-31b284ae{0%{stroke-dasharray:0,56;stroke-dashoffset:0}50%{stroke-dasharray:0,56;stroke-dashoffset:0}100%{stroke-dasharray:56,330;stroke-dashoffset:0}}@keyframes draw-second-line-data-v-31b284ae{0%{stroke-dasharray:0,55;stroke-dashoffset:1}50%{stroke-dasharray:0,55;stroke-dashoffset:1}100%{stroke-dasharray:55,0;stroke-dashoffset:70}}.alert-sign[data-v-31b284ae]{stroke-width:6.25;stroke-linecap:round;position:absolute;top:40px;left:68px;width:15px;height:70px;animation:.5s alert-sign-bounce-data-v-31b284ae cubic-bezier(.175,.885,.32,1.275)}.alert-sign .dot[data-v-31b284ae]{stroke:none;fill:#ffc107}@keyframes alert-sign-bounce-data-v-31b284ae{0%{transform:scale(0);opacity:0}50%{transform:scale(0);opacity:1}100%{transform:scale(1)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-31b284ae";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),

var entry_esm = /*#__PURE__*/(() => {
  // Get component instance
  const installable = __vue_component__; // Attach install function executed by Vue.use()

  installable.install = (Vue, vuetify = null, optionsUse = {}) => {
    if (!vuetify) {
      console.error('Use Vue.use(TSweetAlertVuetify, vuetify)');
    }
    const property = optionsUse.property || '$swal';
    const Ctor = Vue.extend(Object.assign({
      vuetify
    }, __vue_component__));
    let cmp;

    function createTSweetAlertVuetify(options) {
      var _cmp;

      (_cmp = cmp) === null || _cmp === void 0 ? void 0 : _cmp.close();
      const container = document.querySelector('[data-app=true]') || document.body;
      return new Promise(resolve => {
        cmp = new Ctor(Object.assign({}, {
          propsData: Object.assign({}, options),
          destroyed: () => {
            container.removeChild(cmp.$el);
            resolve(cmp.valueReturn);
          }
        }));
        container.appendChild(cmp.$mount().$el);
      });
    }

    function open(alertDefault, config = {}) {
      return createTSweetAlertVuetify({
        alertDefault,
        config,
        closeDestroy: true,
        modelSweet: true
      });
    }

    function close() {
      var _cmp2;

      (_cmp2 = cmp) === null || _cmp2 === void 0 ? void 0 : _cmp2.close();
    }
    Vue.prototype[property] = open;
    Vue.prototype[property].close = close;
    Vue.component('TSweetAlertVuetify', installable);
  };

  return installable;
})();

export default entry_esm;
